export type Theme = 'light' | 'dark' | 'system';

export const getInitialTheme = (): Theme => {
  if (typeof window === 'undefined') return 'system';
  return (localStorage.getItem('theme') as Theme) || 'system';
};

export const applyTheme = (theme: Theme) => {
  const root = document.documentElement;
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

  // Remove existing theme classes
  root.classList.remove('dark', 'light');
  document.body.classList.remove('dark', 'light');

  // Apply new theme
  if (theme === 'system') {
    const isDark = prefersDark.matches;
    if (isDark) {
      root.classList.add('dark');
      document.body.classList.add('dark');
    }
  } else {
    if (theme === 'dark') {
      root.classList.add('dark');
      document.body.classList.add('dark');
    }
  }

  // Save theme preference
  localStorage.setItem('theme', theme);
};
